export default __webpack_public_path__ + "f69d1d0e2d3bb0a95b531312d9b8c3ae.webp";